import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import cx from 'classnames';


import { KeyCodes } from 'constants/constants';
import { useDebounce, useDebounceValue } from 'utils/components';

import Input from 'components/forms/Input';
import TextInput from 'components/forms/TextInput';


const SearchInput = React.forwardRef(({ type = 'text', minLength = 3, searchWait = 500, results, value, renderItem, onSearch, onCancel, onItemSelect, className, ...props }, ref) => {
  const [highlighted, setHighlighted] = useState();
  const debouncedValue = useDebounceValue(value, searchWait);

  useEffect(() => {
    if(debouncedValue && debouncedValue.length >= minLength) 
      onSearch?.(value);
  }, [debouncedValue])
  
  
  const onItemClick = idx => {
    onItemSelect?.(results?.[idx]);
  }

  const onKeyDown = e => {
    let code = e.keyCode;
    let value = e.target.value;

    if(_.size(results) === 0) {
      if(code === KeyCodes.ENTER) {
        e.preventDefault();
        e.stopPropagation();
        return onSearch?.(value);
      } 
      return;
    }

    switch(code) {
      case KeyCodes.UP_ARROW:
        setHighlighted(((highlighted ?? 1) - 1) % _.size(results));
        e.preventDefault()
        break;
      case KeyCodes.DOWN_ARROW:
        setHighlighted(((highlighted ?? -1) + 1) % _.size(results));
        e.preventDefault()
        break;
      case KeyCodes.ENTER:
        onItemClick(highlighted);
        e.preventDefault();
        break;
      case KeyCodes.ESCAPE:
        onCancel?.();
        e.preventDefault();
        break;
    }
  }

  const onChangeInput = (e, onChange) => {
    let value = e.target.value;
    onChange?.(e);

  }


  const defaultProps = {
    placeholder: "Enter Search Term",
    focus: "false",
    label: "Search",
  }
  return (<>
    <Input
      value={value}
      {...defaultProps}
      {...props}
      ref={ref}
      className={cx("text search", className)}
      renderInput={inputProps => (
        <input 
          type={type} 
          {...defaultProps} 
          {...inputProps} 
          onKeyDown={onKeyDown}
          onChange={e => onChangeInput(e, inputProps.onChange)} /> //
      )} />

      {results && (_.size(results) > 0) &&
      <div className={cx("g-search-results g-drop-down", { empty: _.isEmpty(results) })}>
        {_.map(results, (item, idx) => (
          <div 
            key={idx}
            className={cx("result-item", { selected: idx === highlighted })}
            onClick={e => onItemClick(idx)}>
            {renderItem?.(item)}
          </div>))}
      </div>}
  </>)
})
export default SearchInput;


export class SearchInput2 extends React.Component {
  _inputRef = null;

  static defaultProps = {
    type: "text",
    value: null,
    errors: [],
    autoFocus: false,
    focus: "false",
    label: "Search",
    placeholder: 'Enter Search Term',
  }

  state = {
    highlighted: 0,
    selected: null,
  }

  getInput() {
    return this._inputRef;
  }

  getValue = () => {
    var { value, name, valueTransformer } = this.props;
    if(_.isFunction(valueTransformer)) {
      return valueTransformer(value) || "";
    }
    return value || "";
  }

  onKeyDown = e => {
    let { results } = this.props;
    let { highlighted } = this.state;
    let code = e.keyCode;

    if(!results)
      return;

    switch(code) {
      case KeyCodes.UP_ARROW:
        this.setState({ selected: (highlighted - 1) % _.size(results) });
        break;
      case KeyCodes.DOWN_ARROW:
        this.setState({ selected: (highlighted + 1) % _.size(results) });
        break;
      case KeyCodes.ENTER:
        this.onItemSelect(highlighted);
    }
  }

  onChange = e => {
    let { minLength, onChange, onSearch } = this.props;
    let value = e.target.value;
    onChange?.(e);
    if(value.length >= minLength)
      onSearch?.(value);
  }

  onItemSelect = idx => this.props.onItemSelect?.(this.props.results?.[idx])

  renderErrors = (errSet, children) => {
    let keep = _.without(errSet, ...VALIDATING_STATES);
    return React.Children.map(children, child => {
      if(!child.props || !child.props.type) return null;
      return _.includes(keep, child.props.type) ? child : null;
    });
  }

  render() {
    let { name, value, id, label, children, errors, onRenderItem, onChange, onSearch, onItemSelect, results, valueReducer, valueTransformer,
      className, helper, prefix, autoComplete = 'off', ...props } = this.props;
    let { highlighted } = this.state;
    id = id ?? `input-${name}`;

    return (
      <div className={cx("input text g-search", className, { disabled: props.disabled, ['with-prefix']: _.isString(prefix) })}>
        {label &&
          <label htmlFor={id}>{label}</label>}
        <div className="input-wrap">
          {prefix &&
            <div className="prefix">{prefix}</div>}
          <input
            type="text"
            id={id}
            name={name}
            ref={this._inputRef}
            value={this.getValue()}
            placeholder="Enter Search Term"
            autoComplete={autoComplete}
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
            {...props} />
          {children}

          {results && (_.size(results) > 0) &&
            <div className={cx("g-search-results", { empty: _.isEmpty(results) })}>
              {_.map(results, (item, idx) => (
                <div
                  className={cx("result-item", { selected: idx === highlighted })}
                  onClick={e => this.onItemSelect(idx)}>
                  {onRenderItem?.(item)}
                </div>))}
            </div>}
        </div>
      </div>);
  }
}